import React from "react";
import { useIsAuthenticated } from "@azure/msal-react";
import Login from "./Login";
import Unauthorized from "./Unauthorized";
import useGroupMembership from "../../hooks/useGroupMembership";

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = useIsAuthenticated();
  const { isMember, loading } = useGroupMembership();

  // Step 1: not logged in → show login page
  if (!isAuthenticated) {
    return <Login />;
  }

  // Step 2: checking group membership → show a simple loader
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <div
          style={{
            width: 40,
            height: 40,
            border: "4px solid #e0e0e0",
            borderTopColor: "#003df5",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
          }}
        />
        <span style={{ color: "#666", fontSize: "0.95rem" }}>
          Verifying access…
        </span>
      </div>
    );
  }

  // Step 3: logged in but NOT in the AD group → show unauthorized page
  if (!isMember) {
    return <Unauthorized />;
  }

  // Step 4: authenticated + authorized → render the protected page
  return children;
};

export default ProtectedRoute;
